import {log} from '../api/logger';

const loggedExceptionMap = {};

const guarded = (selectorName, selector) => {
    return function guardedSelector(args) {
        let result;

        try {
            result = selector(args);
        } catch (err) {
            if (loggedExceptionMap[selectorName]) {
                loggedExceptionMap[selectorName]++;
                return result;
            }

            log({
                selectorException: true,
                selectorName,
                message: err.message,
                stack: err.stack.substring(0, 200)
            });

            loggedExceptionMap[selectorName] = 1;
        }

        return result;
    };
};

export default guarded;
